module.exports = __webpack_public_path__ + "media/images/area/feature/chugoku/banner/th-00af4ecc2372580e3f3645cd2734074e.jpg";